import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type CreateOrderBody = NonNullable<
  paths['/api/v1/orders']['post']['requestBody']
>['content']['application/json'];
export type CreateOrderResponse =
  paths['/api/v1/orders']['post']['responses'][200]['content']['application/json']['order'];
export type RequestPayLetterResponse =
  paths['/api/v1/orders/{uuid}/request_pay_letter']['post']['responses'][200]['content']['application/json'];
export type RequestPayLetterBody = NonNullable<
  paths['/api/v1/orders/{uuid}/request_pay_letter']['post']['requestBody']
>['content']['application/json'];
export type PayLetterPaymentMethod =
  | 'creditcard'
  | 'kakaopay'
  | 'payco'
  | 'checkpay'
  | 'toss'
  | 'ssgpay'
  | 'naverpay'
  | 'samsungpay'
  | 'applepay';

export async function createOrder(body: CreateOrderBody): Promise<CreateOrderResponse> {
  const { data, error } = await client.POST('/api/v1/orders', {
    body,
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when creating order');
  return data.order;
}

export async function requestPayLetter(
  orderId: string,
  paymentMethod?: PayLetterPaymentMethod,
  options?: {
    autopay?: boolean;
  }
): Promise<RequestPayLetterResponse> {
  const body: RequestPayLetterBody = {};

  if (paymentMethod) {
    body.payment_method = paymentMethod;
  }

  if (options?.autopay) {
    body.autopay = true;
  }

  const { data, error } = await client.POST('/api/v1/orders/{uuid}/request_pay_letter', {
    params: {
      path: {
        uuid: orderId
      }
    },
    body,
    headers: authHeaders()
  });

  if (error) throw error;
  if (!data) throw new Error('Empty response when requesting pay letter');

  return data;
}
